import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import d3 from 'd3'
import i18n from './i18n'


var debug = false
// var debug = true

Vue.config.productionTip = !debug
Vue.prototype.$http = axios
if (debug)
  Vue.prototype.$API_URL = "http://localhost:9090/api/";
else
  Vue.prototype.$API_URL = "http://maxisu.api.yazilimsalcozumler.com/api/";

window.myvue = new Vue({
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
